import React from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ReactComponent as EditSVG } from "go-core/images/svg/actions/edit.svg";
import { LiveOrderApi } from "../../../../../../../../../../../../services/Api/Organization/types";

interface Props {
	order: LiveOrderApi;
	setShowFiscalizationModal: (value: boolean) => void;
}

const LiveOrdersOrderPreviewStatus = ({ order, setShowFiscalizationModal }: Props) => {
	const { t } = useTranslation();

	const isOrderFiscalized = () =>
		order?.fiscalization?.status === "FISCALIZED" || order?.fiscalization?.status === "FISCALIZED_RECEIVED";

	const getTitle = () => {
		switch (order.status) {
			case "CLOSED":
			case "VOIDED": {
				const fiscalizedTitle = isOrderFiscalized()
					? t("enums.orders.fiscalization.FISCALIZED")
					: t("enums.orders.fiscalization.NOT_FISCALIZED");
				return `${t(`enums.common.status.${order.status}`)} ${t(
					"modules.live_order.field.and.title"
				)} ${fiscalizedTitle}`;
			}
			default:
				return t(`enums.common.status.${order.status}`);
		}
	};

	const getTitleColor = () => {
		switch (order.status) {
			case "CLOSED":
			case "VOIDED": {
				if (isOrderFiscalized()) return "text-dark";
				return "text-danger";
			}
			default:
				return "text-dark";
		}
	};

	return (
		<>
			<div className="d-flex">
				<div>
					<span className="label">{t("modules.live_order.field.status.title")}</span>
					<h5 className={getTitleColor()}>{getTitle()}</h5>
				</div>
				<Button
					disabled={isOrderFiscalized()}
					onClick={() => setShowFiscalizationModal(true)}
					className="ms-auto my-auto icon-button"
				>
					<EditSVG className="edit-icon" />
				</Button>
			</div>
			<hr />
		</>
	);
};

export default LiveOrdersOrderPreviewStatus;
